import {
  formatRawAsDate,
  formatRawAsISO,
} from "core-integration/src/utils/datetime";
import SortDescIcon from "plos/src/img/icons/sort-down.svg?react";
import SortAscIcon from "plos/src/img/icons/sort-up.svg?react";
import SortIcon from "plos/src/img/icons/sort.svg?react";
import { useEffect, useState } from "react";
import {
  EventNameAndDateStyles,
  FDRHeadingStyles,
  HeaderStyles,
  SortingIconStyles,
  SortingWrapperStyles,
} from "./fdrHeadingCell.css";
import { FDRHeadingProps } from "./types";

const FDRHeadingCell = ({
  id,
  eventName = "Heading",
  eventDeadline,
  onHandleClick,
  activeEventId,
}: FDRHeadingProps) => {
  const [active, setActive] = useState(true);
  const [, setIsTeam] = useState(true);
  const [sortOrderAsc, setOrderAsc] = useState(true);

  useEffect(() => {
    if (activeEventId !== id) {
      setOrderAsc(false);
      setActive(false);
      setIsTeam(false);
    }
  }, [id, activeEventId]);

  function handleHeadingClick() {
    const newOrderAsc = !sortOrderAsc;
    setOrderAsc(newOrderAsc);
    setActive(true);
    onHandleClick(id, newOrderAsc ? "asc" : "dsc");
  }

  return (
    <div className={FDRHeadingStyles} onClick={handleHeadingClick}>
      <header className={HeaderStyles}>
        <div className={EventNameAndDateStyles}>{eventName}</div>
        {eventDeadline && (
          <time
            className={EventNameAndDateStyles}
            dateTime={formatRawAsISO(eventDeadline)}
          >
            {formatRawAsDate(eventDeadline)}
          </time>
        )}
      </header>
      <div className={SortingWrapperStyles}>
        {active ? (
          <>
            {sortOrderAsc ? (
              <SortAscIcon className={SortingIconStyles} />
            ) : (
              <SortDescIcon className={SortingIconStyles} />
            )}
          </>
        ) : (
          <SortIcon className={SortingIconStyles} />
        )}
      </div>
    </div>
  );
};

export default FDRHeadingCell;
